(function($) {
	var accordion_button = $( ".js-form-accordion" );
	var accordion_form   = $( ".js-contact-form" );
	var form_wrapper     = $( "#js-contact-form-body" );

	function closeContactForm() {
		accordion_form.removeClass( "open" );
		accordion_form.addClass( "closed" );
		form_wrapper.stop( true, false ).slideUp( "slow" );
	}

	function openContactForm() {
		accordion_form.removeClass( "closed" );
		accordion_form.addClass( "open" );
		form_wrapper.stop( true, false ).slideDown( "slow" );
	}

	accordion_button.on(
		"click", function() {
			if (accordion_form.hasClass( "open" )) {
				closeContactForm();
			} else {
				openContactForm();
			}
		}
	);

})( jQuery );
